import React, { useState, useEffect } from "react";
import BASE_URL from "../../../config/config";
// import "../../../css/admin.module.css";
import { useNavigate } from 'react-router-dom';

export default function AddUser() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    phone: "",
    role: "user", // مقدار پیش‌فرض 'user'
  });
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isUsernameAvailable, setIsUsernameAvailable] = useState(null);
  const [isEmailAvailable, setIsEmailAvailable] = useState(null);
  const [isPhoneAvailable, setIsPhoneAvailable] = useState(null);
  const [csrfToken, setCsrfToken] = useState("");
  const [usernameError, setUsernameError] = useState("");

  useEffect(() => {
    const fetchCsrfToken = async () => {
      try {
        const response = await fetch(`${BASE_URL}/csrf-token`, {
          method: "GET",
          credentials: "include",
        });
        if (response.ok) {
          const data = await response.json();
          setCsrfToken(data.csrfToken);
        }
      } catch (error) {
        console.error("Error fetching CSRF token:", error);
      }
    };
    fetchCsrfToken();
  }, []);

  const validateUsername = (username) => {
    // فقط حروف انگلیسی بزرگ و کوچک و اعداد مجاز هستند
    const usernameRegex = /^[a-zA-Z0-9]+$/;
    return usernameRegex.test(username) && username.length >= 3;
  };

  const validateEmail = (email) => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const persianArabicRegex = /[\u0600-\u06FF]/;
    if (persianArabicRegex.test(email)) return false;
    return regex.test(email);
  };

  const validatePassword = (password) => {
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return passwordRegex.test(password);
  };

  const checkAvailability = async (field, value) => {
    if (!value) return;

    // اگر نام کاربری غیرمجاز است، بررسی یکتا بودن را انجام نده
    if (field === "username" && !validateUsername(value)) {
      setIsUsernameAvailable(false);
      return;
    }

    try {
      const response = await fetch(`${BASE_URL}/check-${field}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "CSRF-Token": csrfToken,
        },
        credentials: "include",
        body: JSON.stringify({ [field]: value }),
      });

      const data = await response.json();
      if (response.ok) {
        switch (field) {
          case "username":
            setIsUsernameAvailable(data.available);
            break;
          case "email":
            setIsEmailAvailable(data.available);
            break;
          case "phone":
            setIsPhoneAvailable(data.available);
            break;
        }
      }
    } catch (error) {
      console.error(`Error checking ${field} availability:`, error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    // اعتبارسنجی‌های مختلف بر اساس نوع فیلد
    switch (name) {
      case "username":
        if (!validateUsername(value)) {
          if (value.length < 3) {
            setUsernameError("نام کاربری باید حداقل 3 کاراکتر باشد");
          } else {
            setUsernameError(
              "نام کاربری فقط می‌تواند شامل حروف انگلیسی و اعداد باشد"
            );
          }
        } else {
          setUsernameError("");
          if (value.length >= 3) {
            checkAvailability("username", value);
          }
        }
        break;
      case "email":
        if (!validateEmail(value)) {
          setMessage("لطفاً یک ایمیل معتبر وارد کنید");
        } else {
          checkAvailability("email", value);
          setMessage("");
        }
        break;
      case "phone":
        if (!/^09\d{9}$/.test(value)) {
          setMessage("شماره موبایل باید 11 رقم و با 09 شروع شود");
        } else {
          checkAvailability("phone", value);
          setMessage("");
        }
        break;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage("");

    // اعتبارسنجی‌های اولیه
    if (
      !formData.username ||
      !formData.email ||
      !formData.password ||
      !formData.phone
    ) {
      setMessage("لطفاً تمام فیلدها را پر کنید");
      setIsLoading(false);
      return;
    }

    // اعتبارسنجی نام کاربری
    if (!validateUsername(formData.username)) {
      if (formData.username.length < 3) {
        setMessage("نام کاربری باید حداقل 3 کاراکتر باشد");
      } else {
        setMessage("نام کاربری فقط می‌تواند شامل حروف انگلیسی و اعداد باشد");
      }
      setIsLoading(false);
      return;
    }

    // اعتبارسنجی پسورد
    if (!validatePassword(formData.password)) {
      setMessage(
        "رمز عبور باید حداقل 8 کاراکتر و شامل حروف بزرگ، کوچک، اعداد و علائم خاص باشد"
      );
      setIsLoading(false);
      return;
    }

    try {
      const response = await fetch(`${BASE_URL}/admin/add-user`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "CSRF-Token": csrfToken,
        },
        credentials: "include",
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage("کاربر با موفقیت اضافه شد");
        setFormData({
          username: "",
          email: "",
          password: "",
          phone: "",
          role: "user",
        });
        setIsUsernameAvailable(null);
        setIsEmailAvailable(null);
        setIsPhoneAvailable(null);
        setUsernameError("");
        setTimeout(() => {
          navigate('/admin/users/list'); // هدایت به صفحه لیست کاربران
      }, 2000); // تاخیر 2 ثانیه‌ای برای نمایش پیام موفقیت
      } else {
        setMessage(data.message || "خطا در افزودن کاربر");
      }
    } catch (error) {
      setMessage("خطا در برقراری ارتباط با سرور");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="add-user-container">
      <h2>افزودن کاربر جدید</h2>
      <form onSubmit={handleSubmit} className="add-user-form">
        <div className="form-group">
          <label htmlFor="username">نام کاربری:</label>
          <input
            type="text"
            id="username"
            name="username"
            value={formData.username}
            onChange={handleChange}
            required
          />
          {usernameError && <span className="error">{usernameError}</span>}
          {!usernameError && isUsernameAvailable !== null && (
            <span className={isUsernameAvailable ? "success" : "error"}>
              {isUsernameAvailable
                ? "نام کاربری قابل استفاده است"
                : "این نام کاربری قبلاً ثبت شده است"}
            </span>
          )}
          <small className="input-hint">فقط حروف انگلیسی و اعداد مجاز هستند (حداقل 3 کاراکتر)</small>
        </div>

        <div className="form-group">
          <label htmlFor="email">ایمیل:</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          {isEmailAvailable !== null && (
            <span className={isEmailAvailable ? "success" : "error"}>
              {isEmailAvailable
                ? "ایمیل قابل استفاده است"
                : "این ایمیل قبلاً ثبت شده است"}
            </span>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="phone">شماره موبایل:</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            maxLength={11}
            placeholder="09123456789"
            required
          />
          {isPhoneAvailable !== null && (
            <span className={isPhoneAvailable ? "success" : "error"}>
              {isPhoneAvailable
                ? "شماره موبایل قابل استفاده است"
                : "این شماره موبایل قبلاً ثبت شده است"}
            </span>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="password">رمز عبور:</label>
          <input
            type="password"
            id="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
          />
          <small className="password-hint">
            رمز عبور باید حداقل 8 کاراکتر و شامل حروف بزرگ، کوچک، اعداد و علائم
            خاص باشد
          </small>
        </div>

        <div className="form-group">
          <label htmlFor="role">نقش کاربری:</label>
          <select
            id="role"
            name="role"
            value={formData.role}
            onChange={handleChange}
            className="role-select"
          >
            <option value="user">کاربر</option>
            <option value="admin">مدیر</option>
          </select>
        </div>

        {message && (
          <div
            className={
              message.includes("موفقیت") ? "success-message" : "error-message"
            }
          >
            {message}
          </div>
        )}

        <button
          type="submit"
          disabled={
            isLoading ||
            !isUsernameAvailable ||
            !isEmailAvailable ||
            !isPhoneAvailable ||
            !!usernameError
          }
        >
          {isLoading ? "در حال افزودن..." : "افزودن کاربر"}
        </button>
      </form>
    </div>
  );
}
